
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Alert, Button } from '@mui/material'
import { Business as BusinessIcon } from '@mui/icons-material'

import DefaultEntityConsult from 'components/form/DefaultEntityConsult'
import RodadaPermissionsCard from 'components/RodadaPermissionsCard'
import { useRodadaPermissions } from 'hooks/useRodadaPermissions'
import { useAppContext } from 'app/AppContext'
import Rodada from 'entity/Rodada'

export default function RodadaConsulta() {
    const navigate = useNavigate()
    const { setActionsView } = useAppContext()
    const { permissions, loading, uidPerfil } = useRodadaPermissions()

    useEffect(() => {
        const actions = []

        // Só adiciona o botão "Nova Rodada" se o usuário tem permissão
        if (permissions.canCreate || permissions.isAdmin) {
            actions.push({
                uid: "novaRodada",
                text: "Nova Rodada",
                iconName: "Add",
                sequence: "10",
                action: () => {
                    navigate("/rodada");
                },
            })
        }

        setActionsView(actions)

        return () => {
            setActionsView([])
        }
    }, [navigate, setActionsView, permissions])

    const extraQuery = (query) => {
        // if (!permissions.isAdmin) {
        // Aqui você precisaria adicionar um campo "criadoPor" ou "empresaId" na entidade Rodada
        if (uidPerfil) {

            if (!permissions.isAdmin) {
                query = query.where('perfisAutorizado.' + uidPerfil, '==', true)
            }
        } else {
            return query.where('uid', '==', '') // Retorna vazio se não tiver perfil logado
        }
        // para filtrar apenas as rodadas da empresa logada
        // return query.where('empresaId', '==', userProfile.uid)
        // }
        return query;


    }
    const extraFilter = (query) => {
        // Ordenação decrescente por data de início
        return query.sort((a, b) => {
            const dataInicioA = new Date(a.dataInicio).getTime()
            const dataInicioB = new Date(b.dataInicio).getTime()
            return dataInicioB - dataInicioA
        })
    }

    return (
        <Box>
            {/* Card de Permissões */}
            <RodadaPermissionsCard permissions={permissions} loading={loading} />

            {/* Alerta se não pode cadastrar
            {!loading && !permissions.canCreate && !permissions.isAdmin && (
                <Alert
                    severity="info"
                    sx={{ mb: 2 }}

                >
                    {permissions.reason}
                </Alert>
            )} */}

            <DefaultEntityConsult
                EntityClass={Rodada}
                initialFilters={{ status: "ATIVO" }}
                titulo={"Consulta de Rodadas"}
                routeForm={'rodada'}
                extraFilter={extraFilter}
                extraQuery={extraQuery}
                // Desabilita a criação via botão padrão se não tem permissão
                hideCreateButton={!permissions.canCreate && !permissions.isAdmin}
            />
        </Box>
    )
}
